/**
 * Здесь все запускается до того как загрузится основной скрипт
 */
import { BrowserPlatform } from "./lib/platform/browser";

if (!window.platform) {
    window.platform = new BrowserPlatform();
}

console.log("used platform", window.platform.name);
